// extracted by mini-css-extract-plugin
export default {"paginator":"Paginator_paginator__DOWt2","pageNumber":"Paginator_pageNumber__-wvOZ","selectedPages":"Paginator_selectedPages__aflhL"};